import type { ReactNode } from 'react';
import { useCallback, useState } from 'react';

import { showModal } from 'zustand-stores/modalStore';

type Props = {
  listingId: string;
  listingType: string;
  userType?: string;
  userContextListingType?: string;
  userContextListingId?: string;
  render: (renderProps: { flagListing: () => void }) => ReactNode;
};

export function FlagListingContainer({
  listingId,
  listingType,
  userType,
  userContextListingType,
  userContextListingId,
  render,
}: Props) {
  const [flagged, setFlagged] = useState(false);

  const showFlagListingModal = useCallback(() => {
    showModal('FLAG_LISTING', {
      listingId,
      listingType,
      userType,
      userContextListingType,
      userContextListingId,
      onFlagged: () => setFlagged(true),
    });
  }, [
    listingId,
    listingType,
    userType,
    userContextListingType,
    userContextListingId,
  ]);

  if (flagged) return null;

  return render({ flagListing: showFlagListingModal });
}
